/* import __COLOCATED_TEMPLATE__ from './email-group-user-chooser-row.hbs'; */
import SelectKitRowComponent from "select-kit/components/select-kit/select-kit-row";
export default SelectKitRowComponent.extend({
  classNames: ["email-group-user-chooser-row"]
});